import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { toFixedWithoutRounding } from "../../Utils/Constant";
import { Link } from "react-router-dom";

const eventTypeToGameType = (eventType) => {
  const key = String(eventType);
  return key === "4"
    ? "cricket"
    : key === "2"
      ? "tennis"
      : key === "1"
        ? "soccer"
        : key === "3"
          ? "casino"
          : undefined;
};

const resolveGameType = (item) =>
  item?.gameType || eventTypeToGameType(item?.eventType);

const eventTypeLabel = (gameType) => {
  return ["cricket", "4"].includes(gameType)
    ? "Cricket"
    : ["tennis", "2"].includes(gameType)
      ? "Tennis"
      : ["soccer", "1"].includes(gameType)
        ? "Soccer"
        : "Sports";
};

// Splits runners using the event name ("Team A v Team B"): Team A first,
// Team B last, any remaining runner (The Draw) in the middle.
// Falls back to array order if the names can't be matched.
const splitRunnersByEvent = (runners = [], eventName = "") => {
  const list = runners || [];
  const [n1, n2] = String(eventName || "")
    .split(/\s+(?:v|vs\.?)\s+/i)
    .map((s) => s.trim().toLowerCase());
  const same = (r, n) => {
    const rn = String(r?.RunnerName || "").trim().toLowerCase();
    return !!n && !!rn && (rn === n || rn.includes(n) || n.includes(rn));
  };
  let team1 = list.find((r) => same(r, n1));
  let team2 = list.find((r) => r !== team1 && same(r, n2));
  let draw = null;

  if (team1 && team2) {
    draw = list.find((r) => r !== team1 && r !== team2) || null;
  } else if (list.length > 2) {
    draw =
      list.find((r) => /draw/i.test(r?.RunnerName || "")) ||
      list[list.length - 1];
    const teams = list.filter((r) => r !== draw);
    team1 = teams[0];
    team2 = teams[1];
  } else {
    team1 = list[0];
    team2 = list[1];
  }
  return { team1, team2, draw };
};

const plSign = (value) => (Math.sign(value) == -1 ? "red" : "green");
const plLabel = (value) =>
  value === undefined || value === null
    ? "-"
    : Math.sign(value) === -1
      ? `(${Math.abs(value).toFixed(2)})`
      : Number(value).toFixed(2);

const RiskInnerNew = ({ setShow, setModal, sport }) => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const [openId, setOpenId] = useState("");
  const [loader, setLoader] = useState(true);

  const [betFairData, setBetFairData] = useState([]);
  const [betFaireDataCheck, setBetFaireDataCheck] = useState(false);

  const [fancyList, setFancyList] = useState([]);
  const [fancyDataCheck, setFancyDataCheck] = useState(false);

  const [bookmakerData, setBookmakerData] = useState([]);
  const [bookmakerDataCheck, setBookmakerDataCheck] = useState(false);

  // --- Premium: sportBook + premiumCricket combined, same shape as
  // RiskManagement.jsx's getRiskPremiumData ---
  const [premiumList, setPremiumList] = useState([]);
  const [premiumDataCheck, setPremiumDataCheck] = useState(false);

  const getOdds = async (marketIds, config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds + `?marketId=${marketIds?.join(",")}&multi=true`,
      {},
      config,
    );
    if (
      status === 200 &&
      response_users.success &&
      response_users.results?.length > 0
    ) {
      setBetFairData((current) =>
        current.map((match) => {
          const newObj = response_users.results.find(
            (res) => res?.mi === match?.marketId,
          );
          if (match?.marketId === newObj?.mi) {
            const back_odds = newObj.rt?.filter((rt) => rt.ib) || [];
            const lay_odds = newObj.rt?.filter((rt) => !rt.ib) || [];
            return {
              ...match,
              back_odds,
              lay_odds,
              totalMatched: newObj?.totalMatched,
            };
          }
          return match;
        }),
      );
    }
  };
  const getRiskData = async (config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskMatchList,
      { userId: user._id, userType: user.userType },
      config,
    );
    if (status === 200 && response_users.success) {
      setBetFaireDataCheck(true);
      if (response_users.results?.length > 0) {
        const sorted = [...response_users.results].sort(
          (a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime),
        );
        setBetFairData(sorted);
        getOdds(
          sorted.map((res) => res?.marketId),
          config,
        );
      } else {
        setBetFairData([]);
      }
    }
  };

  const getRiskFancyData = async (config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskManagementFancy,
      {},
      config,
    );
    if (status === 200 && response_users.success) {
      setFancyDataCheck(true);
      setFancyList(response_users?.results || []);
    }
  };

  const getOddsBookmaker = async (eventIds, config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookmakerOdds + `?eventId=${eventIds?.join(",")}&multi=true`,
      {},
      config,
    );
    if (
      status === 200 &&
      response_users.success &&
      response_users.results?.length > 0
    ) {
      setBookmakerData((current) =>
        current.map((match) => {
          const newObj = response_users.results.find(
            (res) => res?.mi === match?.marketId,
          );
          if (match?.marketId === newObj?.mi) {
            const back_odds = newObj?.rt?.filter((rt) => rt.ib) || [];
            const lay_odds = newObj?.rt?.filter((rt) => !rt.ib) || [];
            return { ...match, back_odds, lay_odds };
          }
          return match;
        }),
      );
    }
  };

  const getRiskDataBookmaker = async (config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskMatchListBookmaker,
      {},
      config,
    );
    if (status === 200 && response_users.success) {
      setBookmakerDataCheck(true);
      if (response_users.results?.length > 0) {
        const sorted = [...response_users.results].sort(
          (a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime),
        );
        setBookmakerData(sorted);
        getOddsBookmaker(
          sorted.map((res) => res?.eventId),
          config,
        );
      } else {
        setBookmakerData([]);
      }
    }
  };

  // --- Premium: combines sportBook + premiumCricket into one list, same
  // as the old RiskManagement.jsx getRiskPremiumData ---
  const getRiskPremiumData = async (config = {}) => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskManagementPremium,
      {},
      config,
    );
    if (status === 200 && response_users.success && response_users.results) {
      const combined = [
        ...(response_users.results?.sportBook || []),
        ...(response_users.results?.premiumCricket || []),
      ];
      setPremiumDataCheck(true);
      setPremiumList(combined);
    }
  };

  useEffect(() => {
    getRiskData();
    getRiskFancyData();
    getRiskDataBookmaker();
    getRiskPremiumData();
  }, []);

  useEffect(() => {
    // background auto-refresh: skip the global loader, only the first load shows it
    const intervalID = setInterval(() => {
      getRiskData({ skipLoader: true });
      getRiskFancyData({ skipLoader: true });
      getRiskDataBookmaker({ skipLoader: true });
      getRiskPremiumData({ skipLoader: true });
    }, 15 * 1000);
    return () => clearInterval(intervalID);
  }, []);

  useEffect(() => {
    if (!openId) return;
    setLoader(true);
    const timer = setTimeout(() => setLoader(false), 1000);
    return () => clearTimeout(timer);
  }, [openId]);

  const toggleRow = (rowKey) =>
    setOpenId((prev) => (prev === rowKey ? "" : rowKey));

  const fancyByEvent = fancyList.reduce((acc, f) => {
    const key = f?.eventId;
    if (!key) return acc;
    if (!acc[key]) acc[key] = [];
    acc[key].push(f);
    return acc;
  }, {});

  const bookmakerByEvent = bookmakerData.reduce((acc, b) => {
    const key = b?.eventId;
    if (!key || acc[key]) return acc;
    acc[key] = b;
    return acc;
  }, {});
  // premium: a match can have multiple premium markets (sportbook +
  // premium cricket lines), so group like fancy
  const premiumByEvent = premiumList.reduce((acc, p) => {
    const key = p?.eventId;
    if (!key) return acc;
    if (!acc[key]) acc[key] = [];
    acc[key].push(p);
    return acc;
  }, {});
  const matchOddsByEvent = betFairData.reduce((acc, m) => {
    if (m?.eventId) acc[m.eventId] = m;
    return acc;
  }, {});

  const allEventIds = new Set([
    ...Object.keys(matchOddsByEvent),
    ...Object.keys(bookmakerByEvent),
    ...Object.keys(fancyByEvent),
    ...Object.keys(premiumByEvent),
  ]);

  const combinedMatches = Array.from(allEventIds)
    .map((eventId) => {
      const oddsMatch = matchOddsByEvent[eventId];
      const bookmakerMatch = bookmakerByEvent[eventId];
      const fancyItems = fancyByEvent[eventId] || [];
      const premiumItems = premiumByEvent[eventId] || [];

      if (oddsMatch) {
        return {
          ...oddsMatch,
          gameType: resolveGameType(oddsMatch),
          hasMatchOdds: true,
          hasBookmaker: !!bookmakerMatch,
          bookmaker: bookmakerMatch || null,
        };
      }

      // no match odds — fall back through bookmaker, fancy, then premium
      // for display fields
      const first = bookmakerMatch || fancyItems[0] || premiumItems[0] || {};
      return {
        eventId,
        marketId: first.marketId || null,
        eventName: first?.eventName || first?.matchName,
        gameType: resolveGameType(first),
        eventDateTime: first?.eventDateTime,
        status: first?.status,
        runners: [],
        position: [],
        hasMatchOdds: false,
        hasBookmaker: !!bookmakerMatch,
        bookmaker: bookmakerMatch || null,
      };
    })
    .sort((a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime));
  const dataReady =
    betFaireDataCheck &&
    fancyDataCheck &&
    bookmakerDataCheck &&
    premiumDataCheck;

  const filteredData =
    !sport || sport === "all"
      ? combinedMatches
      : combinedMatches.filter((match) => match?.gameType === sport);

  const sportOrder = { cricket: 0, soccer: 1, tennis: 2 };
  const orderedFilteredData = [...filteredData].sort((a, b) => {
    const orderA = sportOrder[a?.gameType] ?? 3;
    const orderB = sportOrder[b?.gameType] ?? 3;
    return (
      orderA - orderB || new Date(b.eventDateTime) - new Date(a.eventDateTime)
    );
  });


  const sportCategories = [
    { id: "cricket", label: "Cricket", icon: "cricket.png" },
    { id: "soccer", label: "Soccer", icon: "soccer.png" },
    { id: "tennis", label: "Tennis", icon: "tennis.png" },
  ]
    .filter((category) => !sport || sport === "all" || sport === category.id)
    .map((category) => ({
      ...category,
      matches: orderedFilteredData.filter(
        (match) => match?.gameType === category.id,
      ),
    }));

  const renderMatch = (match) => {
    const rowKey = match?.marketId || match?.eventId;
    const isOpen = openId === rowKey;
    const runners = match?.runners || [];
    const positionFor = (selectionId) =>
      match?.position?.find((p) => p?.selectionId == selectionId)?.position;

    // Team 1 / Team 2 come from the event name, The Draw goes in the middle
    const {
      team1,
      team2,
      draw: drawRunner,
    } = splitRunnersByEvent(runners, match?.eventName);

    const orderedRunners = drawRunner
      ? [team1, drawRunner, team2].filter(Boolean)
      : [team1, team2].filter(Boolean);

    const col1 = team1 ? positionFor(team1?.SelectionId) : 0;
    const colX = drawRunner ? positionFor(drawRunner?.SelectionId) : 0;
    const col2 = team2 ? positionFor(team2?.SelectionId) : 0;

    const matchFancyList = fancyByEvent[match?.eventId] || [];
    const matchPremiumList = premiumByEvent[match?.eventId] || [];
    const bookmaker = match?.bookmaker;
    const bookmakerRunners = bookmaker?.bookmakerRunners || [];

    const bookmakerPositionFor = (selectionID) =>
      bookmaker?.position?.find((p) => p?.selectionId == selectionID)?.position;

    // Each value is colored by its own sign
    const col1Color = plSign(col1);
    const colXColor = plSign(colX);
    const col2Color = plSign(col2);
    return (
      <tbody key={rowKey} id={`content_MATCH_ODDS_DRAW_${rowKey}`}>
        <tr className="border-t" id={`tempTr_MATCH_ODDS_DRAW_${rowKey}`}>
          <td
            rowSpan={2}
            id="0_1"
            className="align-L"
            style={{ padding: "8px 10px" }}
          >
            <a href="#" id="eventType">
              {eventTypeLabel(match?.gameType)}
            </a>
          </td>
          <td
            rowSpan={2}
            id="1_1"
            className="align-L border-l"
            style={{ padding: "8px 10px" }}
          >
            {" "}
            {match?.hasMatchOdds
              ? "Match Odds"
              : match?.hasBookmaker
                ? "Book Maker"
                : "Fancy"}{" "}
          </td>
          <td
            id="linerh"
            className="align-L border-l"
            style={{ padding: "8px 10px" }}
          >
            <a
              onClick={() => toggleRow(rowKey)}
              className={`btn ${isOpen ? "open" : "close"}-odds`}
              style={{ cursor: "pointer" }}
              name={`oddsBtn_${rowKey}`}
            >
              Open
            </a>
            {match?.eventId && match?.marketId ? (
              // to={`/match-details/${match.eventId}/${match.marketId}`}
              <Link to={`/match-details/${match.eventId}/${match.marketId}`} id="marketPath">
                <strong id="eventName">{match?.eventName}</strong>
              </Link>
            ) : (
              <strong id="eventName">{match?.eventName}</strong>
            )}
          </td>

          <td className="border-l" style={{ padding: "11px" }}>
            <a className={col1Color}>{plLabel(col1) || "0.00"}</a>
          </td>
          <td style={{ padding: "11px" }}>
            <a className={colXColor}>{plLabel(colX) || "0.00"}</a>
          </td>
          <td style={{ padding: "11px" }}>
            <a className={col2Color}>{plLabel(col2) || "0.00"}</a>
          </td>

          <td className="align-C border-l">
            <a
              onClick={() => {
                if (runners?.length > 0) {
                  setShow({
                    status: true,
                    id: user?._id,
                    userType: user?.userType,
                    eventId: match?.eventId,
                    marketId: match?.marketId,
                    type: "Match Odds",
                  });
                } else {
                  toast.warning(
                    "Market Is Not Match Odds..Please Expand From Arrow Button To See Books",
                  );
                }
              }}
              style={{ width: "100%", cursor: "pointer" }}
              id="view"
              className="btn"
            >
              View
            </a>
          </td>
        </tr>

        <tr
          className="expanded marketsSection"
          style={{ display: isOpen ? "table-row" : "none" }}
          id={`expand_${rowKey}`}
        >
          <td colSpan={4} className="border-l align-L">
            <img
              src="/assets/images/transparent.gif"
              className="expand-arrow"
            />
            <div className="iframert" style={{ height: "400px" }}>
              {loader ? (
                <div className="overlay">
                  <div className="loading-container1">
                    <div id="loading" className="loader1">
                      <div className="line" />
                      <div className="line" />
                      <div className="line" />
                      <div className="line" />
                      <div className="line" />
                      <div className="line" />
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {match?.hasMatchOdds && (
                    <div className="for-agent">
                      <div className="head-bets-agent">
                        <span
                          id="lowLiquidity"
                          className="game-low_liq"
                          style={{ display: "none" }}
                        >
                          Low Liquidity
                        </span>
                        <dl className="game-matched">
                          <dt>Match Odds</dt>
                        </dl>
                        <dl className="game-matched">
                          <dt>Matched</dt>
                        </dl>
                        {match?.status == "in_play" && (
                          <ul className="game-info">
                            <li id="inPlay">
                              <img
                                src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                                className="icon-irun"
                              />
                              In-Play{" "}
                            </li>
                          </ul>
                        )}
                      </div>
                      <div className="bets-wrap">
                        <span className="refer_only">
                          <span id="selectionCount">{runners.length}</span>{" "}
                          Selections
                        </span>
                        <table
                          id="marketOdds"
                          className="bets table-responsive"
                        >
                          <tbody>
                            <tr className="bet-all">
                              <td />
                              <td
                                colSpan={2}
                                id="backPercent"
                                className="refer-bet"
                              >
                                {" "}
                                0.0%
                              </td>
                              <td>
                                <a className="back-all">
                                  <span>Back all</span>
                                </a>
                              </td>
                              <td>
                                <a className="lay-all">
                                  <span>Lay all</span>
                                </a>
                              </td>
                              <td
                                colSpan={2}
                                id="layPercent"
                                style={{ textAlign: "right" }}
                                className="refer-book"
                              >
                                0.0%{" "}
                              </td>
                            </tr>
                          </tbody>
                          <tbody id="content">
                            {orderedRunners.map((runner) => {
                              const position = positionFor(runner?.SelectionId);
                              const backOdds =
                                match?.back_odds?.filter(
                                  (o) => o.ri === runner?.SelectionId,
                                ) || [];
                              const layOdds =
                                match?.lay_odds?.filter(
                                  (o) => o.ri === runner?.SelectionId,
                                ) || [];
                              return (
                                <tr
                                  key={runner?.SelectionId}
                                  id={`selection_${runner?.SelectionId}`}
                                >
                                  <th id="selection">
                                    <p>
                                      <a id="marketDepth">
                                        <img
                                          src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                                          className="icon-predict"
                                        />
                                      </a>
                                      {runner?.RunnerName}
                                      <span
                                        style={{ float: "right" }}
                                        className={plSign(position)}
                                      >
                                        {plLabel(position)}
                                      </span>
                                    </p>
                                  </th>
                                  <td
                                    className="back-3"
                                    id={`back_3_${runner?.SelectionId}`}
                                  >
                                    <a>{backOdds[2]?.rt ?? "-"}</a>
                                    <span>{backOdds[2]?.bv ?? ""}</span>
                                  </td>
                                  <td
                                    className="back-2"
                                    id={`back_2_${runner?.SelectionId}`}
                                  >
                                    <a>{backOdds[1]?.rt ?? "-"}</a>
                                    <span>{backOdds[1]?.bv ?? ""}</span>
                                  </td>
                                  <td
                                    className="back-1"
                                    id={`back_1_${runner?.SelectionId}`}
                                  >
                                    <a>{backOdds[0]?.rt ?? "-"}</a>
                                    <span>{backOdds[0]?.bv ?? ""}</span>
                                  </td>
                                  <td
                                    className="lay-1"
                                    id={`lay_1_${runner?.SelectionId}`}
                                  >
                                    <a>{layOdds[0]?.rt ?? "-"}</a>
                                    <span>{layOdds[0]?.bv ?? ""}</span>
                                  </td>
                                  <td
                                    className="lay-2"
                                    id={`lay_2_${runner?.SelectionId}`}
                                  >
                                    <a>{layOdds[1]?.rt ?? "-"}</a>
                                    <span>{layOdds[1]?.bv ?? ""}</span>
                                  </td>
                                  <td
                                    className="lay-3"
                                    id={`lay_3_${runner?.SelectionId}`}
                                  >
                                    <a>{layOdds[2]?.rt ?? "-"}</a>
                                    <span>{layOdds[2]?.bv ?? ""}</span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {match?.hasBookmaker && bookmaker && (
                    <div
                      className="bets-wrap bookmaker_bet"
                      id={`bookMakerWrap__${rowKey}`}
                    >
                      <table
                        id="bookMakerMarketList"
                        className="bets bets-bookmaker table-responsive"
                      >
                        <colgroup>
                          <col span={1} width={280} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                        </colgroup>
                        <tbody style={{ display: "table-row-group" }}>
                          <tr className="colgroup-adjust">
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          <tr
                            id="bookMakerSpecialBet"
                            className="special_bet"
                            style={{
                              backgroundColor: "rgb(240, 244, 246)",
                            }}
                          >
                            <td colSpan={6}>
                              <h3
                                style={{
                                  margin: "auto",
                                  textAlign: "left",
                                  height: "100%",
                                  lineHeight: "normal",
                                }}
                              >
                                <p
                                  style={{
                                    color: "black",
                                    paddingTop: "5px",
                                  }}
                                >
                                  Bookmaker
                                </p>
                              </h3>
                            </td>
                            <td className="border-l">
                              <a
                                onClick={() =>
                                  setShow({
                                    status: true,
                                    id: user?._id,
                                    userType: user?.userType,
                                    eventId: match?.eventId,
                                    marketId: bookmaker?.marketId,
                                    type: "Book Maker",
                                  })
                                }
                                id="view"
                                className="btn"
                                style={{ cursor: "pointer" }}
                              >
                                View
                              </a>
                            </td>
                          </tr>
                          <tr className="bet-all">
                            <td colSpan={3} />
                            <td>Back</td>
                            <td>Lay</td>
                            <td colSpan={2} className="refer-book" />
                          </tr>

                          {bookmakerRunners.map((runner) => {
                            const position = bookmakerPositionFor(
                              runner?.selectionID,
                            );

                            const back = bookmaker?.back_odds?.find(
                              (o) => o?.runnerName == runner?.runnerName,
                            );
                            const lay = bookmaker?.lay_odds?.find(
                              (o) => o?.runnerName == runner?.runnerName,
                            );

                            const isSuspended = back?.rt > 0 && lay?.rt > 0;

                            return (
                              <React.Fragment key={runner?.selectionID}>
                                {!isSuspended && (
                                  <tr
                                    id={`bookMakerSuspend_${runner?.selectionID}`}
                                    className="fancy-suspend-tr"
                                  >
                                    <th></th>
                                    <td
                                      colSpan={6}
                                      className="fancy-suspend-td"
                                    >
                                      <div
                                        id="suspendClass"
                                        className="fancy-suspend"
                                      >
                                        <span id="info">Suspend</span>
                                      </div>
                                    </td>
                                  </tr>
                                )}

                                <tr
                                  id={`bookMakerSelection_${runner?.selectionID}`}
                                >
                                  <th className="predict">
                                    <p id="runnerName">
                                      {runner?.runnerName}{" "}
                                      <span
                                        style={{ float: "right" }}
                                        className={plSign(position)}
                                      >
                                        {plLabel(position)}
                                      </span>
                                    </p>
                                  </th>
                                  <td colSpan={3}>
                                    <dl className="back-gradient">
                                      <dd
                                        id="back_3"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <p />
                                      </dd>
                                      <dd
                                        id="back_2"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <p />
                                      </dd>
                                      <dd
                                        id="back_1"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <a>{back?.rt ?? "-"}</a>
                                      </dd>
                                    </dl>
                                  </td>
                                  <td colSpan={3}>
                                    <dl className="lay-gradient">
                                      <dd
                                        id="lay_1"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <a>{lay?.rt ?? "-"}</a>
                                      </dd>
                                      <dd
                                        id="lay_2"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <p />
                                      </dd>
                                      <dd
                                        id="lay_3"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <p />
                                      </dd>
                                    </dl>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {matchFancyList.length > 0 && (
                    <div
                      name="multiMarketItem"
                      className="bets-wrap fancy_bet"
                      id={`fancyBetTable_${rowKey}`}
                    >
                      <table
                        id="fancyBetMarketList"
                        className="bets table-responsive"
                      >
                        <colgroup>
                          <col span={1} width={280} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                          <col span={1} width={70} />
                        </colgroup>
                        <tbody>
                          <tr className="colgroup-adjust">
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          <tr
                            id="fancyBetSpecialBet"
                            className="special_bet"
                            style={{
                              backgroundColor: "rgb(240, 244, 246)",
                            }}
                          >
                            <td colSpan={6}>
                              <h3
                                style={{
                                  height: "100%",
                                  lineHeight: "normal",
                                  display: "flex",
                                  paddingTop: "10px",
                                }}
                              >
                                <p style={{ color: "black" }}>Fancy</p>
                              </h3>
                            </td>
                          </tr>
                          <tr className="bet-all">
                            <td />
                            <td colSpan={2} className="refer-bet" />
                            <td>No</td>
                            <td>Yes</td>
                            <td colSpan={2} className="refer-book" />
                          </tr>

                          {matchFancyList.map((fancy) => {
                            const rt = fancy?.jsonData?.[0]?.rt || [];
                            const layOdds = rt.find((o) => o.ib === false);
                            const backOdds = rt.find((o) => o.ib === true);

                            return (
                              <tr
                                key={fancy?.selectionId}
                                id={`fancyBetMarket_${fancy?.selectionId}`}
                                className="fancybet"
                              >
                                <th colSpan={3}>
                                  <dl className="fancy-th-layout">
                                    <dt>
                                      <p id="marketName">{fancy?.fancyName}</p>
                                    </dt>
                                    <dd className="dd-tips">
                                      <a
                                        style={{
                                          textDecoration: "none",
                                        }}
                                        className="red"
                                      >
                                        <span>
                                          {fancy?.positionLoseAmount
                                            ? `(-${fancy.positionLoseAmount})`
                                            : 0}
                                        </span>
                                      </a>
                                      <ul className="fancy-tips">
                                        <a
                                          onClick={() =>
                                            setModal({
                                              status: true,
                                              eventId: fancy?.eventId,
                                              marketId: fancy?.marketId,
                                              selectionId: fancy?.selectionId,
                                              fancyName: fancy?.fancyName,
                                            })
                                          }
                                          id="fancyBetBookBtn"
                                          className="btn-book"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          Book
                                        </a>
                                      </ul>
                                    </dd>
                                  </dl>
                                </th>
                                <td colSpan={2} className="multi_select">
                                  <ul>
                                    <li id="lay_1" className="lay-1">
                                      <a id="runsInfo">
                                        {layOdds?.rt ?? "-"}
                                        <span>{layOdds?.pt ?? ""}</span>
                                      </a>
                                    </li>
                                    <li id="back_1" className="back-1">
                                      <a id="runsInfo">
                                        {backOdds?.rt ?? "-"}
                                        <span>{backOdds?.pt ?? ""}</span>
                                      </a>
                                    </li>
                                  </ul>
                                </td>
                                <td colSpan={2} className="td-fancy_merge" />
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* --- Premium block --- */}
                  {matchPremiumList.length > 0 && (
                    <div>
                      <div className="bets-wrap">
                        <span className="refer_only" />
                        <table className="table01 table-responsive">
                          <tbody>
                            <tr>
                              <th rowSpan={2} className="align-L">
                                Premium - Event/Market Name{" "}
                              </th>
                              <th
                                width="21%"
                                colSpan={3}
                                className="align-C border-l bg-yellow"
                              >
                                Player P/L
                              </th>
                            </tr>
                            <tr>
                              <th
                                width="7%"
                                className="border-l bg-yellow"
                                style={{ textAlign: "center" }}
                              >
                                1
                              </th>
                              <th
                                width="7%"
                                className="bg-yellow"
                                style={{ textAlign: "center" }}
                              >
                                X
                              </th>
                              <th
                                width="7%"
                                className="bg-yellow"
                                style={{ textAlign: "center" }}
                              >
                                2
                              </th>
                            </tr>
                          </tbody>
                          <tbody id="content_Sportradar">
                            {matchPremiumList.map((premium, idx) => {
                              const runner1 = premium?.jsonData?.[0];
                              const runnerDraw =
                                premium?.jsonData?.length > 2
                                  ? premium?.jsonData?.[2]
                                  : null;

                              const premiumPositionFor = (selectionId) =>
                                premium?.position?.find(
                                  (p) => p?.selectionId == selectionId,
                                )?.position;

                              const posX = runnerDraw
                                ? premiumPositionFor(runnerDraw?.SelectionId)
                                : 0;

                              return (
                                <tr
                                  key={premium?.marketId || idx}
                                  className="border-t"
                                >
                                  <td className="align-L border-l">
                                    <a
                                      onClick={() =>
                                        setShow({
                                          status: true,
                                          id: user?._id,
                                          userType: user?.userType,
                                          eventId: match?.eventId,
                                          marketId: premium?.marketId,
                                          selectionId: premium?.selectionId,
                                          type: "SportsBook",
                                        })
                                      }
                                      href="#"
                                      id="marketPath"
                                    >
                                      <strong
                                        id={`eventName-${premium?.eventId}`}
                                      >
                                        {premium?.eventName ||
                                          premium?.matchName}
                                      </strong>
                                      <img
                                        src="/assets/images/transparent.gif"
                                        className="fromto"
                                      />
                                      <span
                                        id={`marketName-${premium?.marketId}`}
                                      >
                                        {" "}
                                        {premium?.fancyName}
                                      </span>
                                    </a>
                                  </td>
                                  <td className="border-l align-C">
                                    <a
                                      className={plSign(
                                        premium?.positionLoseAmount,
                                      )}
                                    >
                                      {toFixedWithoutRounding(
                                        premium?.positionLoseAmount,
                                      )}
                                    </a>
                                  </td>
                                  <td className="border-l align-C">
                                    <a className={plSign(posX)}>
                                      {plLabel(posX)}
                                    </a>
                                  </td>
                                  <td className="border-l align-C">
                                    <a className={plSign(-1)}>
                                      {toFixedWithoutRounding(
                                        premium?.positionProfitAmount,
                                      )}
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </td>
          <td width={80} className="border-l" />
        </tr>
      </tbody>
    );
  };
  return (
    <div className="risk-inner-scope">
      {(dataReady &&
      sportCategories.every((category) => category.matches.length === 0)
        ? sportCategories
        : sportCategories.filter(
            (category) => !dataReady || category.matches.length > 0,
          )
      ).map((category) => (
        <div className="match-wrap1" key={category.id}>
          <div className="total_all">
            <h2>Match Odds</h2>
            <h2>
              <img
                className="png-match"
                src={`/assets/images/${category.icon}`}
              />
            </h2>
            <a
              id={`refresh_Match_Odds_${category.id}`}
              className="btn_replay"
              onClick={(e) => {
                e.preventDefault();
                getRiskData();
                getRiskFancyData();
                getRiskDataBookmaker();
                getRiskPremiumData();
              }}
            >
              <img src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw==" />
            </a>
          </div>
          <table className="table011 risk_matchodd table-responsive data-table">
            <tbody>
              <tr>
                <th width="10%" rowSpan={2} className="align-L">
                  Sports
                </th>
                <th width="8.1%" rowSpan={2} className="align-L">
                  Market
                </th>
                <th rowSpan={2} className="align-L">
                  Event/Market Name
                </th>
                <th
                  width="21%"
                  colSpan={3}
                  className="align-C border-l bg-yellow"
                >
                  Player P/L
                </th>
                <th width="6%" rowSpan={2} className="align-C border-l">
                  Downline P/L
                </th>
              </tr>
              <tr>
                <th width="7%" className="border-l bg-yellow">
                  1
                </th>
                <th width="7%" className="bg-yellow">
                  X
                </th>
                <th width="7%" className="bg-yellow">
                  2
                </th>
              </tr>
            </tbody>
            {!dataReady ? (
              <tbody>
                <tr>
                  <td colSpan={7}>Loading...</td>
                </tr>
              </tbody>
            ) : category.matches.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan={7}>
                    There are currently no matched bets for this market
                  </td>
                </tr>
              </tbody>
            ) : (
              category.matches.map(renderMatch)
            )}
          </table>
        </div>
      ))}
    </div>
  );
};

export default RiskInnerNew;
